import {
  ERROR_ON_GETTING_MATERIAL_USAGE_OF_PRINTER, ERROR_ON_GETTING_PRINTS_NUMBER, RECEIVED_MATERIAL_USAGE_OF_PRINTER,
  RECEIVED_PRINTS_NUMBER,
  START_FETCHING_MATERIAL_USAGE_OF_PRINTER
} from "../actions/types";

const initState = {};

const PrinterStatisticsReducer = (state = initState, action) => {
  const { type, payload } = action;
  let printerId, prevStateOfPrinter, newStateOfPrinter;

  switch (type) {
    case START_FETCHING_MATERIAL_USAGE_OF_PRINTER:
    case RECEIVED_MATERIAL_USAGE_OF_PRINTER:
    case ERROR_ON_GETTING_MATERIAL_USAGE_OF_PRINTER:
      printerId = Object.keys(payload)[0];
      prevStateOfPrinter = state[printerId];
      newStateOfPrinter = payload[printerId];
      return { ...state, [printerId]: { ...prevStateOfPrinter, ...newStateOfPrinter } }
    case RECEIVED_PRINTS_NUMBER:
    case ERROR_ON_GETTING_PRINTS_NUMBER:
      printerId = Object.keys(payload)[0];
      prevStateOfPrinter = state[printerId];
      newStateOfPrinter = payload[printerId];
      return { ...state, [printerId]: { ...prevStateOfPrinter, ...newStateOfPrinter } }
    default:
      return state;
  }
}

export default PrinterStatisticsReducer;


// WEBPACK FOOTER //
// ./src/reducers/printer-statistics-reducer.js